<template>
    <BasePanel
        headline="lang_LABEL_CONTRACTS_CAPTION_RESERVES"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :items-per-page="300"
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
            <!-- TOP SLOT -->
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col 
                            cols="3"
                            align-self="end"
                        >
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>

            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.sourceOfReserve`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-source-of-reserve'">
                        {{ item.sourceOfReserve }}
                    </div>
                </template>
                <template v-slot:[`item.setUpAccrualsIn`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-text-setup-accruals-in'"
                    >
                        {{ $alvPlugin.displayPeriod(item.setUpAccrualsIn) }}
                    </div>
                </template>
                <template v-slot:[`item.reverseAccrualsIn`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-text-reverse-accruals-in'"
                    >
                        {{ $alvPlugin.displayPeriod(item.reverseAccrualsIn) }}
                    </div>
                </template>
                <template v-slot:[`item.enteredOn`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-text-entered-on'"
                    >
                        {{ item.enteredOn !== null && item.enteredOn !== '0000-00-00' ? $d(new Date(item.enteredOn), 'alvDateFormat') : '' }}
                    </div>
                </template>
                <template v-slot:[`item.entered`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-entered'">
                        {{ getEnteredTranslation(item.entered) }}
                    </div>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-text-amount'"
                    >
                        {{ $n(item.amount, 'number') }}
                    </div>
                </template>
                <template v-slot:[`item.reserve`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-text-reserve'"
                    >
                        {{ $n(item.reserve, 'number') }}
                    </div>
                </template>
            
            <!-- Buttons -->
                <template v-slot:[`item.inlineEdit`]="{ item }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item)"
                    />
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-icon-delete'"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>
    
<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "LabelContractsReservesEditPanel",
    components: {
        BasePanel,
        BaseIcon,
        BaseButton
    },
    data() {
        return {
            alvqa: 'contracts-label-edit-form-panel-reserves'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("lang_LABEL_CONTRACTS_RESERVES_SOURCE"), 
                    align: "left", 
                    value: "sourceOfReserve",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-source-of-reserve'
                },
                {
                    text: this.$t("lang_LABEL_CONTRACTS_CAPTION_SETUP_ACCRUALS_IN"), 
                    align: "right", 
                    value: "setUpAccrualsIn",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-setup-accruals-in'
                },
                {
                    text: this.$t("lang_LABEL_CONTRACTS_CAPTION_REVERSE_ACCRUALS_IN"), 
                    align: "right", 
                    value: "reverseAccrualsIn",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-reverse-accruals-in'
                },
                {
                    text: this.$t("lang_LABEL_CONTRACTS_RESERVES_ENTERED"), 
                    align: "right", 
                    value: "enteredOn",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-entered'
                },
                {
                    text: this.$t("lang_LABEL_CONTRACTS_RESERVES_ENTRY"), 
                    align: "left", 
                    value: "entered",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-entry'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_AMOUNT") + ' ' + this.$store.getters.getSelectedCurrency, 
                    align: "right", 
                    value: "amount",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-amount'
                },
                {
                    text: this.$t("lang_LABEL_CONTRACTS_CAPTION_RESERVE") + ' ' + this.$store.getters.getSelectedCurrency, 
                    align: "right", 
                    value: "reserve",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-reserve'
                },
                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    class: 'text-no-wrap'
                }
            ]
        },
        listItems() { return this.$store.getters.getLabelContractsReserves }
    },
     methods: {
        getEnteredTranslation(enteredValue) {
            if(enteredValue === 'manual') return this.$t('lang_GENERIC_CAPTION_MANUAL')
            if(enteredValue === 'automatic') return this.$t('lang_GENERIC_CAPTION_AUTOMATIC')
        },
        deleteRow(item) {
            // set the selected row that should be deleted from the delete action 
            // and open the deletion dialog
            this.$store.commit("setSelectedLabelContractsReserves", item)
            this.$store.commit('setDeletionDialogContext', 'SelectedLabelContractsReserves')
            this.$store.commit('setShowDeletionDialog', true)
        },
        addNewRow() {
            this.$store.commit('setShowLabelContractsReservesEditingDialog', true)
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultLabelContractsReserves)) 
            this.$store.commit('setLabelContractsReservesEditingDialogDetails', defaultValues)
        },
        editInlineFunction(item) {
            this.$store.commit('setSelectedLabelContractsReserves', item.id)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))

            detailsDeepCopy['amount'] = this.$n(detailsDeepCopy['amount'], 'number')
            detailsDeepCopy['reserve'] = this.$n(detailsDeepCopy['reserve'], 'number')

            // set the copy in dialog details to edit
            this.$store.commit('setLabelContractsReservesEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowLabelContractsReservesEditingDialog', true) 
        },
    }
}
</script>